
















import Vue from "vue";
import WorldViewForm from "@/components/organisms/WorldViewForm.vue";
import ButtonDefault from "@/components/atoms/ButtonDefault.vue";
import ImageSelector from "@/components/molecules/ImageSelector.vue";
import { submitImage } from "@/lib/image-save";
import { callApi } from "@/lib/api";
import { showOkCancelDialog } from "@/lib/dialog";

export default Vue.extend({
  components: { WorldViewForm, ButtonDefault, ImageSelector },
  props: {
    novelId: String,
    worldViewId: String,
    worldView: Object,
  },
  data() {
    return {
      model: null,
      image: null,
    };
  },
  async created() {
    if (this.worldView) {
      const {
        worldView: { worldViewId, name, detail, additionalColumn },
        image,
      } = this;
      this.model = { worldViewId, name, image, detail, additionalColumn };
      return;
    }
    const GetWorldView = `
    query GetWorldView($input: GetWorldViewInput!) {
      worldView (input: $input) {
        name
        image
        detail {
          name
          value
        }
        additionalColumn {
          name
          label
          content
        }
      }
    }
    `;
    const { novelId, worldViewId } = this;
    const { worldView } = await callApi(GetWorldView, {
      input: {
        novelId,
        worldViewId,
      },
    });
    this.image = worldView.image;
    this.model = { ...worldView, worldViewId };
  },
  methods: {
    change() {
      this.setModified(true);
    },
    imagePath() {
      const { novelId, worldViewId, image } = this;
      if (!image) return null;
      if (image.startsWith("file:")) {
        return `file:novels/${novelId}/worldviews/${worldViewId}.jpg`;
      } else if (image.startsWith("preset:")) {
        return image;
      }
      return null;
    },
    async submit() {
      const { novelId, worldViewId, model, image } = this;
      const UpdateWorldView = `
      mutation UpdateWorldView($input: UpdateWorldViewInput!) {
        updateWorldView (input: $input) {
          novelId
          worldViewId
          image
          createdAt
          updatedAt
        }  
      }`;
      const { additionalColumn } = model;
      model.additionalColumn = additionalColumn.filter((item) => item.label || item.content);
      await callApi(UpdateWorldView, {
        input: {
          novelId,
          worldViewId,
          ...model,
          image,
        },
      });
      await submitImage(`novels/${novelId}/worldviews/${worldViewId}.jpg`);

      this.$notify({
        title: "保存しました",
        type: "success",
      });

      this.setModified(false);

      this.$router.push({
        name: "worldViews",
        params: { novelId, worldViewId },
      });
    },
    async deleteWorldView() {
      const yes = await showOkCancelDialog({
        title: "確認",
        content: "本当に世界観を削除しますか？",
        okButton: "削除する",
      });

      if (!yes) {
        return;
      }
      const { novelId, worldViewId } = this;
      const Query = `
        mutation Delete($input: DeleteWorldViewInput!) {
          deleteWorldView (input: $input) {
            novelId
          }
        }`;
      await callApi(Query, {
        input: {
          novelId,
          worldViewId,
        },
      });

      this.$notify({
        title: "削除しました",
        type: "error",
      });

      this.setModified(false);

      this.$router.push({ name: "worldViews" });
    },
  },
});
